import { client } from "@/hono";
import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { CalculationsMenu } from "./calculations-menu";
import { columns } from "./table-config";

export function Calculations() {
	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["calculations"],
		queryFn: async () => {
			const response = await client.calculations.index.$get();
			const data = await responseHandler(response);
			return data.calculations;
		},
		staleTime: 1_000,
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={data}
				isLoading={isLoading}
				queryKey={queryKey}
				columns={columns}
				persistenceKey="calculations-table"
				menu={<CalculationsMenu />}
				refetch={refetch}
			/>
		</ContentBox>
	);
}
